import axios from "axios";

export const TEMPLATE_INSERT_EVENT_ID = 1070007;
export const PRICING_MODEL_EVENT = {
  CHANGE_PLAN: 1130001,
  TOGGLE_PLAN_TYPE: 1130002,
  VIEW_PAGE: 1130003,
  VIEW_UNPUBLISH_POP_UP: 1130004,
  CONFIRM_UNPUBLISH_PAGE: 1130005,
  CLICK_NOTIFY_AFFILIATE: 1130006,
}
export const VIEW_INSTANT_LANDING_PAGE = 1150001;

export default function trackEvent(params, callback = undefined) {
  try {
    if (!process.env.VUE_APP_ES_TRACKING_ENDPOINT) {
      runCallback(callback);
      return;
    }
    if (!window.___gemShopInfo) {
      runCallback(callback);
      return;
    }

    const timeNowInt = Date.now();
    const timeNow = new Date(timeNowInt);

    const data = {
      created_at: timeNow.toISOString(),
      path: window.location.href,
      uuid: window.uuid,
      shopify_domain: window.___gemShopInfo?.shopifyDomain,
      merchant_email: window.___gemShopInfo?.email,
      merchant_created_at: window.___gemShopInfo?.createdAt,
      merchant_plan: window.___gemShopInfo?.plan,
      event_id: params.eventId,
      properties: {
        ...params?.properties
      },
    }

    axios.post(process.env.VUE_APP_ES_TRACKING_ENDPOINT, data)
      .then(() => runCallback(callback));
  } catch (error) {
    runCallback(callback);
    // eslint-disable-next-line no-console
    console.log('EVENT', error, params);
  }
}

function runCallback(callback) {
  if (callback !== undefined && typeof callback === 'function') {
    callback();
  }
}
